import React, { useState, useEffect } from "react";
import { Link, Route, Redirect, Switch } from "react-router-dom";
import { checkCookies,checkBMAccess } from "./auth";
import { getCookie } from "./Cookies";
import Box from "@material-ui/core/Box";
function PrivateRoute(props) {
  const {
    component: Component,
    authed,

    pagename,
    ...rest
  } = props;
  // //console.log(pagename,"demo");
  return (
    <Route
      {...rest}
      render={(props) =>{
        // //console.log(pagename);
        return (
          checkCookies() ?(         
            (pagename != "signin" && pagename != "signup" && pagename != "forgot" && pagename != "requestsent" && checkBMAccess(pagename))?(
              <Component {...props} />
            ):(
            /* <Redirect to={{ pathname: "/dashboard/home", state: { from: props.location } }}  /> */
            <>
            {getCookie("userRole") == "VPS Admin" || getCookie("userRole") == "Client Admin" ||  getCookie("userRole") == "ClientAdmin"?(
            <Box>
            <Redirect to={{ pathname: "/dashboard/admin", state: { from: props.location } }}  />
            </Box>
            ):(
               <Box>
            <Redirect to={{ pathname: "/dashboard", state: { from: props.location } }}  />
            </Box>
              )}
            </>
            )
          ): (pagename == "signin" || pagename == "signup" || pagename == "forgot" || pagename == "requestsent" || pagename== "newdevice" )?(
            <Component {...props} />
          ):(
            <Redirect to={{ pathname: "/sign-in", state: { from: props.location } }} />
          )
        )
      }
      }
    />
  );
}

export default PrivateRoute;
